import { IconSvg } from 'monica-alexandria'
import styled from 'styled-components'

const CheckboxExtra = styled.label`
  display: grid;
  grid-template-columns: 2.2rem 1fr;
  gap: var(--smallPads);
  align-items: flex-start;
  padding: var(--normalPads);
  border: 0.2rem solid ${p => p.theme.mid};
  border-radius: var(--smallRadius);
  background: ${p => p.theme.background};
  box-shadow: ${p => (p.checked ? p.theme.inFocus : p.theme.out)};
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  opacity: ${p => (p.disabled ? '.6' : '1')};
  transition: border-color .2s, box-shadow .2s, background .2s, opacity .2s;
`

const CheckboxExtraInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`

const CheckboxExtraMark = styled.div`
  height: 2.2rem;
  width: 2.2rem;
  border-radius: 0.5rem;
  border: 0.2rem solid ${p => p.theme.mid};
  background: ${p => (p.checked ? 'var(--main)' : p.theme.background)};
  display: flex;
  align-items: center;
  justify-content: center;

  svg{
    width: 1.4rem;
    height: 1.4rem;
    fill: ${p => p.theme.background};
  }
`

const CheckboxExtraContent = styled.div`
  display: grid;
  gap: 0.4rem;

  h4, p{
    margin: 0;
  }
`

export const Checkbox_Extra = (props) => {
  const handle_change = (event) => {
    props.onChange(event.target.checked, event)
  }

  return (
    <CheckboxExtra
      checked={props.checked}
      disabled={props.disabled}
      aria-disabled={props.disabled}
    >
      <CheckboxExtraInput
        type="checkbox"
        checked={props.checked}
        disabled={props.disabled}
        onChange={handle_change}
      />
      <CheckboxExtraMark checked={props.checked}>
        {props.checked ? <IconSvg Icon="Check" /> : null}
      </CheckboxExtraMark>
      <CheckboxExtraContent>
        {props.title ? (
          <h4>{props.title}</h4>
        ) : (
          props.children
        )}
        {props?.text ? <p>{props.text}</p> : null}
      </CheckboxExtraContent>
    </CheckboxExtra>
  )
}
